import { Extension } from "@tiptap/react";

export interface TextStyleAttributes {
  types: string[];
  fontSize: string[];
  defaultFontSize: string;
}

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    textStyle: {
      setFontSize: (fontSize: string) => ReturnType;
      setLineHeight: (lineHeight: string) => ReturnType;
    };
  }
}

export const FontSize = Extension.create({
  name: "fontSize",

  addOptions() {
    return {
      types: ["textStyle", "paragraph"],
      fontSize: [
        "12px",
        "14px",
        "16px",
        "18px",
        "20px",
        "24px",
        "30px",
        "36px",
      ],
      defaultFontSize: "16px",
    };
  },

  addGlobalAttributes() {
    return [
      {
        types: ["textStyle"],
        attributes: {
          fontSize: {
            default: null,
            parseHTML: (element) => element.style.fontSize || null,
            renderHTML: (attributes) => {
              if (!attributes.fontSize) {
                return {};
              }
              return {
                style: `font-size: ${attributes.fontSize}`,
              };
            },
          },
        },
      },
      {
        types: ["paragraph"],
        attributes: {
          lineHeight: {
            default: null,
            parseHTML: (element) => {
              const raw = element.style.lineHeight || null;
              if (!raw || raw === "normal") return null;
              const px = parseFloat(String(raw).replace(/px$/i, ""));
              if (!Number.isFinite(px) || px <= 0) return null;
              return `${px}px`;
            },
            renderHTML: (attributes) => {
              const raw = attributes.lineHeight;
              if (!raw || typeof raw !== "string") return {};
              const px = parseFloat(String(raw).replace(/px$/i, ""));
              if (!Number.isFinite(px) || px <= 0) return {};
              return {
                style: `line-height: ${px}px`,
              };
            },
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      setFontSize:
        (fontSize: any) =>
        ({ chain }: { chain: any }) => {
          return chain().setMark("textStyle", { fontSize }).run();
        },
      setLineHeight:
        (lineHeight: any) =>
        ({ commands }: { commands: any }) => {
          return this.options.types
            .map((type: any) => commands.updateAttributes(type, { lineHeight }))
            .every((response: any) => response);
        },
    };
  },
});
